/* template */
<template><div><div :style="[(bgStyle)] | transRpxStyle" class="packet-open"><div v-for="(item, index) in (couponList)" :key="item.index" class="coupon"><div class="left"><coupon-price :couponInfo="(item.coupon)"/></div><div class="right"><div class="info"><div class="name">{{item.coupon.name}}</div><div class="usage-limit" v-if="(item.coupon.usage_limit)">{{item.coupon.usage_limit}}</div><div class="valid-period" v-if="(item.coupon.valid_period)">{{item.coupon.valid_period}}</div></div><mpx-button @tap="gotoLink(item)" class="btn" v-if="(item.link)">去使用</mpx-button></div></div><mpx-image :src="(footerBg)" mode="widthFix" class="footer"/></div><div :style="[(btnFooterStyle)] | transRpxStyle" class="footer-btn"><mpx-view @tap="click" class="btn-mock"><div :style="[(btnStyle)] | transRpxStyle" class="btn">{{ btnText }}</div></mpx-view></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m09b1ea94"}'>
  .packet-open
    box-sizing border-box
    background-size 100% 100%
    background-repeat no-repeat
    width 694rpx
    margin-left 31rpx
    padding 12rpx 25rpx 8rpx 19rpx
    position relative
    margin-bottom 48rpx
    .coupon
      width 650rpx
      height 202rpx
      background-image: url('https://ut-static.udache.com/webx/ut/0XnfbbB94dgngv9kYEfqe.png')
      background-size cover
      display flex
      padding 12rpx 29rpx 12rpx 20rpx
      box-sizing border-box
      & +.coupon
        margin-top 21rpx
      .right
        width 370rpx
        flex-shrink 0
        box-sizing border-box
        display flex
        align-self center
        .info
          flex: 1;
          margin-left 20rpx
          .name
            font-size: 32rpx;
            font-family: PingFang SC;
            font-weight: 600;
            color: #B14536;
            text-shadow: 1px 1px 0px #FFF;
            margin-bottom 10rpx
            line-height 1
          .usage-limit, .valid-period
            font-size: 20rpx;
            font-family: PingFang SC;
            font-weight: 400;
            color: #848484;
            line-height 1.4
        .btn
          padding 0
          align-self: center;
          width: 117rpx;
          height: 47rpx;
          background: #E33C2B;
          border-radius: 23rpx;
          text-align center
          line-height 47rpx
          font-size: 22rpx;
          font-family: PingFang SC;
          font-weight: 600;
          color: #FFF;
          &::after
            border none
      .left
        flex 1
        position relative
        padding-bottom: 24rpx
  .footer
    width 694rpx
    position absolute
    bottom -40rpx
    left 0
  .footer-btn
    height: 180rpx;
    background-image: linear-gradient(180deg, rgba(238,126,56,0.00) 0%, #EE7D35 49%);;
    overflow: hidden;
    position fixed
    bottom 0
    z-index 8
    width 100%
    .btn-mock
      margin: 14rpx auto 0;
      width 480rpx;
      height: 100rpx;
      padding 12rpx 32rpx;
    .btn
      width: 100%
      height 100%
      border-radius: 5.33vw
      background-image: linear-gradient(180deg, #FFFDE5 0%, #FFE490 100%);
      box-shadow: 0 12px 20px 0 rgba(224,117,11,1);
      border-radius: 69rpx;
      font-size: 40rpx;
      font-family: PingFang SC;
      font-weight: bold;
      color: #A71818;
      line-height 100rpx
      text-align center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m09b1ea94"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./red-packet-open.mpx.js?isComponent&outputPath=components%2Fred-packet-open09b1ea94%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./red-packet-open.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fred-packet-open09b1ea94%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m09b1ea94"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/red-packet-open09b1ea94/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon-price':getComponent(require("./coupon-price.mpx?isComponent&outputPath=components%2Fcoupon-price9261a862%2Findex")),'mpx-button':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-button.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
